import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as badgeHelper from '../../../helpers/badgeHelper';
import * as appHelper from '../../../helpers/appHelper';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as localStorage from '../../../localStorage/localStorage';

class BadgeButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            badges: this.props.badges,
            totalAchieved: 0,
            updateBadges: false,
            ariaHasPopup: true,
            lang: this.props.lang,
            label: appHelper.getLocaleString("badges_label"),
            collected_label: appHelper.getLocaleString("collected_label")
        };
        this.setBtnClass = this.setBtnClass.bind(this);
        this.setBadgeCount = this.setBadgeCount.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.onClickFunc = this.onClickFunc.bind(this);
        this.getIconClass = this.getIconClass.bind(this);
    }

    componentDidMount() {
        this.setBadgeCount();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.badges !== nextProps.badges) {
            this.setState({
                badges: Object.assign([], nextProps.badges),
                updateBadges: true
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                label: appHelper.getLocaleString("badges_label"),
                collected_label: appHelper.getLocaleString("collected_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.state.updateBadges) {
            this.setBadgeCount();
        }

    }

    setBadgeCount() {
        this.setState({
            updateBadges: false,
            totalAchieved: badgeHelper.getTotalAchievedCount(this.state.badges)
        });

    }

    setBtnClass() {
        return this.props.disabled ? "disabled" : "";
    }

    onClickFunc(){
        this.props.onClickFunc("badgesBtn");
    }

    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.onClickFunc();
        }
    }

    getIconClass(){
        return appHelper.isDefined(localStorage.contentData.experience.badge_shape) && localStorage.contentData.experience.badge_shape === "circle" ? "circle" : "crest";
    }

    render() {
        return (
            <div className={`header-btn badge-btn ${this.setBtnClass()} ${this.getIconClass()}`} onClick={this.onClickFunc} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex={!this.props.disabled ? "0" : "-1"} id="badgesBtn" aria-controls="performance" title={this.state.label} aria-haspopup={this.state.ariaHasPopup} aria-disabled={this.props.disabled}>
                {
                    appHelper.isDefined(localStorage.contentData.experience.badge_shape) && localStorage.contentData.experience.badge_shape === "circle"
                    ?
                        <div className="icon icons8-radio-answered" role="presentation"/>
                    :
                        <div className="icon icons8-achievement-filled" role="presentation"/>
                }

                <div className="badge-count"><span className="status-indicator">{this.state.totalAchieved}</span>
                </div>
                <div className="btn-label">{this.state.label} <span className="hidden-el">{this.state.collected_label}</span></div>
            </div>
        );
    }
}
/*
*  {this.state.showToolTip && !this.props.disabled
                    ? <div className="tool-tip-pointer badge-tool-tip"/>
                    : null
                }*/
BadgeButton.propTypes = {
    onClickFunc: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    badges: PropTypes.array.isRequired,
    bite_id: PropTypes.number,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

BadgeButton.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        badges: state.userData.badges,
        lang:lang
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BadgeButton);



/** WEBPACK FOOTER **
 ** ./src/components/objects/badges/BadgesButton.js
 **/